import styled, { css } from 'styled-components';

export const Casesdesucesso = styled.section`
  background: #e9ebed;
  h3 {
    margin-bottom: 30px;
    text-align: center;
  }

  .content {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    img {
      height: 100px;
      object-fit: contain;
      padding: 0 15px;
      width: 200px;
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              width: 100px;
              height: 50px;
              margin: 10px;
            }
            }
          `
        );
      }}
    }
  }
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;
